var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E8F0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8559 15.5L11.375 18.9375C11.375 20.0767 12.4523 21 13.7812 21C15.0593 21 16.105 20.1454 16.1827 19.0667C16.1834 19.0544 16.1909 19.0544 16.1923 19.0667C16.27 20.1454 17.3157 21 18.5938 21C19.8718 21 20.9175 20.1454 20.9952 19.0667C20.9959 19.0544 21.0034 19.0544 21.0048 19.0667C21.0825 20.1454 22.1282 21 23.4062 21C24.6843 21 25.73 20.1454 25.8077 19.0667C25.8084 19.0544 25.8159 19.0544 25.8173 19.0667C25.895 20.1454 26.9407 21 28.2188 21C29.5477 21 30.625 20.0767 30.625 18.9375L29.1441 15.5H12.8559Z",
    fill: "#002953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.125H29.25V12.0625C29.25 11.683 28.942 11.375 28.5625 11.375H13.4375C13.058 11.375 12.75 11.683 12.75 12.0625V14.125Z",
    fill: "#002953"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.2408V30.6242H29.25V22.2408C28.9214 22.326 28.5769 22.3742 28.2188 22.3742C27.8606 22.3742 27.5175 22.3164 27.1875 22.2305V27.5304C27.1875 27.7202 27.0335 27.8742 26.8438 27.8742H15.1562C14.9665 27.8742 14.8125 27.7202 14.8125 27.5304V22.2305C14.4825 22.3164 14.1394 22.3742 13.7812 22.3742C13.4231 22.3742 13.0786 22.326 12.75 22.2408V22.2408Z",
    fill: "#002953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.ce905078b01609df0b48c58c17d749de.svg";
export { ForwardRef as ReactComponent };